/* eslint-disable react/prop-types */
import SoftBadge from 'components/SoftBadge';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import separate from 'utils/separate'

export default function InvestmentDashboardItem({ item, handleOpenInvestmentTransaction }) {
    const navigate = useNavigate()
    function getRandomHexColor() {
        const randomColor = Math.floor(Math.random() * 16777215).toString(16);
        return `#${randomColor.padStart(6, '0')}`;
    }
    return (
        <section style={{ fontSize: 16, display: "flex", boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px', flexDirection: "column", alignItems: "center", justifyContent: "space-between", width: '25%', padding: "1rem", border: `1px solid ${getRandomHexColor()}`, borderRadius: 10 }}>
            <img src={item.investment_opportunity_logo ? item.investment_opportunity_logo : "/images/logo.png"} alt={item.investment_opportunity_name} style={{ width: 80, height: 80, borderRadius: 100 }} />
            <p style={{ marginTop: 5 }}>{item.investment_opportunity_name}</p>
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", columnGap: 90 }}>
                <section style={{ marginTop: 5, backgroundColor: '#2E8B57', color: "white", fontSize: 12, padding: "0.4rem 0.5rem", borderRadius: 10 }}>
                    <p>{separate(item.total_investment)} تومان</p>
                </section>
                <p style={{ fontSize: 12 }}>تغییرات 24 ساعت اخیر</p>
            </div>
            <div style={{ marginTop: 10, cursor: "pointer" }}>
                <SoftBadge variant="contained"
                    badgeContent="تراکنش ها"
                    onClick={() => handleOpenInvestmentTransaction(item.investment_opportunity_id)}
                    color="secondary" size="xs" />
                <SoftBadge variant="contained"
                    badgeContent="برداشت"
                    color="primary" size="xs" />
                <SoftBadge variant="contained"
                    badgeContent="تغییر قلک"
                    color="info" size="xs" />
                <SoftBadge variant="contained"
                    badgeContent="محاسبه سود"
                    onClick={()=> navigate(`/profitCalculation?investmentOpportunityId=${item.investment_opportunity_id}`)}
                    color="success" size="xs" />
            </div>
        </section>
    )
}
